import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
export interface IPageBuilderState {
  pagesSetting: IPageSetting[]
  currentPageSetting: IPageSetting
  openModalAddPage: boolean,
  snackbarAddPage : ISnackbarAddPage
  commonSettingPageBuilder: {
    colorSetting: string,
    fontSetting: IFontSetting,
    extra?: {
      type: string
      data?: any
      rank?: any
    } | null
  }
  currentPageBuilderSetting?: IDraftThemeItem
  reloadPageBuilderSection: boolean
  finishMigrateData: boolean // kiểm tra trạng thái khi đã migrate xong dữ liệu khi chọn đồng bộ theme
  dataThemeInfoToPreview: any // dữ liệu của theme muốn xem truớc khi muốn đồng bộ
  previewThemeClickCount: number; // số lần bấm preview theme để đồng bộ
  detailThemeData: any;
  isDoneUpdateSection: boolean; // global state quản lý việc khi mà áp dụng dữ liệu page builder mà có chạy api update-section-data, chắc chắn khi chạy xong api này, thì mới dược chạy sang api publish theme
  showModalSurveyWebsiteUsingEasy: boolean;

  // refactor dữ liệu cho phần page-builder
  dataChangePageBuilderByCodeSection : {
    [key: string]: any
  } | null
}

const initialState: IPageBuilderState = {
  pagesSetting: [],
  currentPageSetting: {
    key: '',
    value: ''
  },
  openModalAddPage: false,
  snackbarAddPage: {
    open: false,
    type: 'success'
  },
  commonSettingPageBuilder: {
    colorSetting: 'primary',
    fontSetting: {
      font_family: {
        title: 'Inter',
        description: 'Inter'
      }
    },
    extra: null
  },
  finishMigrateData: false,
  reloadPageBuilderSection: false,
  dataThemeInfoToPreview: null,
  previewThemeClickCount: 0,
  isDoneUpdateSection: false,
  detailThemeData: null,
  dataChangePageBuilderByCodeSection: null,
  showModalSurveyWebsiteUsingEasy: false,
};

export const pageBuilderSlice = createSlice({
  name: "pageBuilder",
  initialState,
  reducers: {
    setPagesSetting: (state, action: PayloadAction<{ value: IPageSetting[] }>) => {
      state.pagesSetting = action.payload.value;
    },
    setCurrentPageSetting: (state, action: PayloadAction<{ value: IPageSetting }>) => {
      state.currentPageSetting = action.payload.value;
    },
    addPageSetting: (state, action: PayloadAction<{ value: IPageSetting }>) => {
      state.pagesSetting.push(action.payload.value);
      state.currentPageSetting = action.payload.value;
    },
    toggleModalAddPage: (state) => {
      state.openModalAddPage = !state.openModalAddPage;
    },
    setSnackbarAddPage: (state, action: PayloadAction<{ value: ISnackbarAddPage }>) => {
      state.snackbarAddPage = action.payload.value;
    },
    setColorSetting: (state, action: PayloadAction<{ value: string }>) => {
      state.commonSettingPageBuilder.colorSetting = action.payload.value;
    },
    setFontSetting: (state, action: PayloadAction<{ value: any }>) => {
      state.commonSettingPageBuilder.fontSetting = action.payload.value;
    },
    setExtraSetting: (state, action: PayloadAction<{ value: {type: string, data?: any, rank?: any} | null }>) => {
      state.commonSettingPageBuilder.extra = action.payload.value;
    },
    setCurrentPageBuilderSetting: (state, action: PayloadAction<{ value: IDraftThemeItem }>) => {
      state.currentPageBuilderSetting = action.payload.value;
    },
    setFinishMigrateData: (state, action: PayloadAction<{ value: boolean }>) => {
      state.finishMigrateData = action.payload.value;
    },
    setReloadPageBuilderSection: (state, action: PayloadAction<{ value: boolean }>) => {
      state.reloadPageBuilderSection = action.payload.value;
    },
    setDataThemeInfoToPreview: (state, action: PayloadAction<{ value: any }>) => {
      state.dataThemeInfoToPreview = action.payload.value;
    },
    incrementPreviewThemeClickCount: (state) => {
      state.previewThemeClickCount += 1;
    },
    resetPreviewThemeClickCount: (state) => {
      state.previewThemeClickCount = 0;
    },
    setIsDoneUpdateSection: (state, action: PayloadAction<{ value: boolean }>) => {
      state.isDoneUpdateSection = action.payload.value;
    },
    setDetailThemeData: (state, action: PayloadAction<{ value: boolean }>) => {
      state.detailThemeData = action.payload.value;
    },
    setDataChangePageBuilderByCodeSection: (state, action: PayloadAction<{ value: { [key: string]: any } | null }>) => {
      state.dataChangePageBuilderByCodeSection = action.payload.value;
    },
    setShowModalSurveyWebsiteUsingEasy: (state, action: PayloadAction<{ value: boolean }>) => {
      state.showModalSurveyWebsiteUsingEasy = action.payload.value;
    }
  },
});

export const {
  setPagesSetting,
  setCurrentPageSetting,
  addPageSetting,
  toggleModalAddPage,
  setSnackbarAddPage,
  setColorSetting,
  setFontSetting,
  setCurrentPageBuilderSetting,
  setFinishMigrateData,
  setExtraSetting,
  setReloadPageBuilderSection,
  setDataThemeInfoToPreview,
  incrementPreviewThemeClickCount,
  resetPreviewThemeClickCount,
  setIsDoneUpdateSection,
  setDataChangePageBuilderByCodeSection,
  setShowModalSurveyWebsiteUsingEasy,
  setDetailThemeData
} = pageBuilderSlice.actions;

export const selectPagesSetting = (state: RootState) =>
  state.pageBuilder.pagesSetting;
export const selectCurrentPageSetting = (state: RootState) =>
  state.pageBuilder.currentPageSetting;
export const selectOpenModalAddPage = (state: RootState) =>
  state.pageBuilder.openModalAddPage;
export const selectSnackbarAddPage = (state: RootState) =>
  state.pageBuilder.snackbarAddPage;
export const selectColorSetting = (state: RootState) =>
  state.pageBuilder.commonSettingPageBuilder.colorSetting;
export const selectFontSetting = (state: RootState) =>
  state.pageBuilder.commonSettingPageBuilder.fontSetting;
export const selectCurrentPageBuilderSetting = (state: RootState) =>
  state.pageBuilder.currentPageBuilderSetting;
export const selectFinishMigrateData = (state: RootState) =>
  state.pageBuilder.finishMigrateData;
export const selectReloadPageBuilderSection = (state: RootState) =>
  state.pageBuilder.reloadPageBuilderSection;
export const selectDataThemeInfoToPreview = (state: RootState) =>
  state.pageBuilder.dataThemeInfoToPreview;
export const selectExtraSetting = (state: RootState) =>
  state.pageBuilder.commonSettingPageBuilder.extra;
export const selectPreviewThemeClickCount = (state: RootState) =>
  state.pageBuilder.previewThemeClickCount;
  export const selectIsDoneUpdateSection = (state: RootState) =>
    state.pageBuilder.isDoneUpdateSection;
export const selectDetailThemeData = (state: RootState) =>
  state.pageBuilder.detailThemeData;
export const selectDataChangePageBuilderByCodeSection = (state: RootState) =>
  state.pageBuilder.dataChangePageBuilderByCodeSection;
export const selectShowModalSurveyWebsiteUsingEasy = (state: RootState) =>
  state.pageBuilder.showModalSurveyWebsiteUsingEasy;

export default pageBuilderSlice.reducer;
